module.exports = __webpack_public_path__ + "static/img/2_1_1.91cfc583.jpg";